const PreRecordCountdown = ({ preRecordCountdown }) => (
  <div className="absolute top-0 w-full h-full backdrop-filter backdrop-blur-lg flex items-center justify-center min-w-full min-h-full z-50">
    <div className="text-9xl font-black text-white opacity-80">
      {preRecordCountdown}
    </div>
  </div>
);

export default PreRecordCountdown;
